<template>
    <div class="web-hook" id="web-hook">
        <div class="web-hook-container">
            <AppBreadCrumb :paths="[{ title: $t('chatbotv2.addWebhook') }]" :select="true" class="new-hook-bread-crumb">
            </AppBreadCrumb>
            <div class="header">
                <div class="page-name">
                    <div class="routes" @click="$router.push({ name: 'integrations-webhook' })">
                        <p>{{ $t("integrations.webhooksNavLabel") }}</p>
                        <span class="arrow">></span>
                    </div>
                    <div class="web-hook-name">{{ form.name.toUpperCase() || $t("integrations.newWebhookTitle") }}</div>
                </div>
                <div class="button-container" @click="saveButtonClickHandler">
                    <div class="save-button">{{ $t("message.save") }}</div>
                </div>
            </div>
            <a-alert
                v-if="$validator.errors.items.length && isSubmitClicked"
                :message="$t('message.error')"
                class="mb-2"
                showIcon
                type="error"
            >
                <div slot="description">
                    <div v-for="err of $validator.errors.items">
                        <span>
                            {{ err.msg }}
                        </span>
                    </div>
                </div>
            </a-alert>
            <a-spin :spinning="loading">
                <a-form class="d-flex flex-column justify-content-center">
                    <div class="form-subtitle"><span style="color: red">*</span> {{ $t("chatbotv2.webhookName") }}</div>
                    <a-form-item class="mb-0">
                        <a-input
                            :placeholder="$t('chatbotv2.yourWebHookName')"
                            v-model="form.name"
                            v-validate="'required'"
                            :name="$t('chatbotv2.yourWebHookName')"
                        />
                    </a-form-item>
                    <div class="form-subtitle"><span style="color: red">*</span> {{ $t("chatbotv2.webHookUrl") }}</div>
                    <a-form-item class="mb-0" name="url" style="position: relative">
                        <a-input
                            :style="{ borderColor: urlError ? 'red' : '#d9d9d9' }"
                            :placeholder="$t('chatbotv2.yourWebHookUrl')"
                            v-model="form.url"
                            v-validate="'required'"
                            :name="$t('chatbotv2.webHookUrl')"
                            @blur="urlInputOnBlurHandler"
                        />
                        <label
                            style="position: absolute; bottom: -42px; left: 0; color: red; margin: 0; padding: 0"
                            v-if="urlError"
                        >
                            {{ $t("chatbotv2.urlTypeError") }}</label
                        >
                    </a-form-item>
                    <div class="form-subtitle">{{ $t("chatbotv2.webHookToken") }}</div>
                    <a-form-item class="mb-0">
                        <a-input
                            :placeholder="$t('chatbotv2.yourVerificationToken')"
                            v-model="form.verificationToken"
                        />
                    </a-form-item>
                    <div class="relative-header">
                        <div class="form-subtitle">{{ $t("chatbotv2.basicAuth") }}</div>
                        <div class="d-flex headers" style="gap: 12px">
                            <a-form-item class="mb-0 w-100">
                                <a-input
                                    :placeholder="$t('chatbotv2.username')"
                                    v-model="form.basicAuthentication.username"
                                />
                            </a-form-item>
                            <a-form-item class="mb-0 w-100">
                                <a-input
                                    :placeholder="$t('chatbotv2.password')"
                                    v-model="form.basicAuthentication.password"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="headers-group">
                        <div class="form-subtitle">{{ $t("integrations.httpHeadersSection") }}</div>

                        <div v-for="(header, index) of anotherHeaders" class="d-flex headers" style="gap: 12px">
                            <a-form-item class="mb-0 w-100">
                                <a-input :placeholder="$t('chatbotv2.enterKey')" v-model="header.key" />
                            </a-form-item>
                            <a-form-item class="mb-0 w-100 header-input">
                                <a-input :placeholder="$t('chatbotv2.value')" v-model="header.value" />
                            </a-form-item>
                            <div class="delete-button" @click="deleteHeader(index)">
                                <md-icon>delete</md-icon>
                            </div>
                        </div>
                    </div>
                </a-form>
            </a-spin>
            <div class="card-wrapper-switches">
                <a-card class="mt-2 w-50">
                    <h5 class="mb-5">{{ $t("message.selectHooks") }}</h5>
                    <div v-for="hook in hooks" :key="hook.name" class="row mb-3">
                        <span class="col-4">{{ hook.value }}</span>
                        <a-switch :checked="selectOption(hook)" class="col-1" @change="onChange(hook.name)" />
                        <button id="visibleBtn" @click="openPreview(hook.name)">
                            <md-icon id="visibleIcon">visibility</md-icon>
                        </button>
                    </div>
                </a-card>
            </div>
        </div>
        <Modal2
            id="previewModal"
            v-if="previewActive"
            :title="`${hookList[selectedHook].type} - Webhook Örneği`"
            @cancel="previewActive = false"
            :show-footer="false"
        >
            <div id="previewArea">
                <vue-json-pretty :data="hookList[this.selectedHook]" />
            </div>
        </Modal2>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { message } from "ant-design-vue";
import Modal2 from "../../../../components/common/Modal2.vue";

import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";

const mockHook = [
    { name: "destroy_chat", value: this?.$t("message.chatClosed") || "Chat kapandı"},
    { name: "score_chat", value: this?.$t("message.scoreChat") || "Chat puanlandı" },
    { name: "create_ticket", value: this?.$t("auto.webhookEventCreateTicket") },
    { name: "update_ticket", value: this?.$t("auto.webhookEventUpdateTicket") },
    { name: "new_user", value: this?.$t("message.newUser") || "Yeni kullanıcı olşuturuldu" },
    { name: "update_user", value: this?.$t("message.updateUser") || "Kullanıcı güncellendi" },
    { name: "delete_user", value: this?.$t("message.deleteUser") || "Kullanıcı silindi" },
    { name: "change_status_representative", value: this?.$t("message.changeStatusRepresent") || "Temsilci durumu değişti" },
    { name: "incoming_message", value: this?.$t("message.incomingMessage") || "Gelen Mesaj" },
    { name: "outgoing_message", value: this?.$t("message.outgoingMessage") ||"Giden Mesaj" },
    { name: "message_updated", value: "Mesaj Güncellendi" },
];
export default {
    name: "WebHookForm",
    components: { VueJsonPretty, Modal2, AppBreadCrumb },
    data() {
        return {
            selectedHook: "",
            previewActive: false,
            modalVisible: true,
            isUpdated: false,
            loading: true,
            editMode: false,
            countEmptyHeader: 0,
            isUpdate: false,
            selectedWebHook: {},
            isError: false,
            urlError: false,
            isSubmitClicked: false,
            anotherHeaders: [{ key: "", value: "" }],
            form: {
                name: "",
                url: "",
                verificationToken: "",
                basicAuthentication: {
                    username: "",
                    password: "",
                },
                headers: [],
                options: [],
            },
            hooks: mockHook,
            hookList: {
                change_status_representative: {
                    id: "3c35b28a-bb61-420f-8092-64b62507bdab",
                    type: "Temsilci durumu değişti",
                    data: {
                        user: [
                            {
                                _id: "6454c69d673677f8ecb52b78",
                                status: "Offline",
                                subjects: [],
                                role: {
                                    _id: "5d344f1f643da6001867ba6e",
                                    siteId: "5d14ee322d95ad001ebdf213",
                                    name: "Full Admin",
                                    permissions: [],
                                    isRoot: true,
                                    isDeleted: false,
                                    createdBy: null,
                                    updatedBy: null,
                                    __v: 0,
                                    createdAt: "2023-01-05T11:29:49.116Z",
                                    updatedAt: "2023-01-05T11:29:49.116Z",
                                },
                                lastLoginIPAddress: "172.20.0.1",
                                lastGeoLocation: null,
                                lastLoginPlatform: "web",
                                lang: "tr",
                                lastActivity: "2023-08-01T08:32:53.824Z",
                                email: "bayzt.irem+34@gmail.com",
                                name: "irem",
                                createdAt: "2023-05-05T09:04:29.655Z",
                                updatedAt: "2023-08-01T08:35:16.519Z",
                            },
                        ],
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878916549,
                },
                create_ticket: {
                    id: "ce46e427-623e-4eb1-a9c3-424a8ac20627",
                    type: "Yeni ticket oluştu",
                    data: {
                        ticket: {
                            _id: "64c8c42ba9388e5e60001b63",
                            tag: "offline_message",
                            status: null,
                            subject: null,
                            visitorEmailAddress: null,
                            visitorPhoneNumber: null,
                            resolved: false,
                            assignedUser: null,
                            resolvedDate: null,
                            rate: 0,
                            response: null,
                            osrPayload: {
                                fullname: "sdfsdf",
                                email: "sdfsdf@qweqwe.com",
                                phone: "90123123",
                                message: "asdasdadasd",
                            },
                            createdByChatbot: false,
                            createdDate: "2023-08-01T08:36:59.669Z",
                            siteId: "5d14ee322d95ad001ebdf213",
                            conversation: null,
                            visitor: {
                                _id: "64785483978d2f4ad8224744",
                                version: {
                                    version: 920,
                                    versionStr: "9.2.0",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                isDeleted: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                preferredLangApproved: false,
                                tags: [],
                                preferredAgents: [],
                                connectionTime: "2023-08-01T08:36:48.884Z",
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 115.0.0 ",
                                ipAddress: "172.20.0.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                siteId: "5d14ee322d95ad001ebdf213",
                                createdAt: "2023-06-01T08:19:15.628Z",
                                updatedAt: "2023-08-01T08:36:49.513Z",
                                __v: 0,
                                visitingPage: "http://localsite.supsis.live/?customer=local",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-15",
                            },
                            __v: 0,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690879019717,
                },
                update_ticket: {
                    id: "668a8a86-dd97-4ed8-b03d-8f7cb26bb83d",
                    type: "Ticket güncellendi",
                    data: {
                        ticket: {
                            _id: "64c17c47e80284c404c07e27",
                            tag: "offline_message",
                            status: null,
                            subject: null,
                            visitorEmailAddress: null,
                            visitorPhoneNumber: null,
                            resolved: true,
                            assignedUser: {
                                _id: "6454c69d673677f8ecb52b78",
                                subjects: [],
                                role: {
                                    _id: "5d344f1f643da6001867ba6e",
                                    name: "Full Admin",
                                },
                                lastLoginIPAddress: "172.20.0.1",
                                lastLoginUserAgent:
                                    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36",
                                lastLoginPlatform: "web",
                                lang: "tr",
                                lastActivity: "2023-08-01T08:32:53.824Z",
                                email: "bayzt.irem+34@gmail.com",
                                name: "irem",
                            },
                            resolvedDate: "2023-08-01T08:37:10.112Z",
                            rate: 0,
                            response: "asdasdasd",
                            osrPayload: {
                                fullname: "asd",
                                email: "asd@asd.com",
                                phone: "90123",
                                message: "asaSas",
                            },
                            createdByChatbot: false,
                            createdDate: "2023-07-26T20:04:23.037Z",
                            siteId: "5d14ee322d95ad001ebdf213",
                            conversation: null,
                            visitor: {
                                _id: "64785483978d2f4ad8224744",
                                version: {
                                    version: 920,
                                    versionStr: "9.2.0",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                isDeleted: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                preferredLangApproved: false,
                                tags: [],
                                preferredAgents: [],
                                connectionTime: "2023-08-01T08:36:48.884Z",
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 115.0.0 ",
                                ipAddress: "172.20.0.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                siteId: "5d14ee322d95ad001ebdf213",
                                createdAt: "2023-06-01T08:19:15.628Z",
                                updatedAt: "2023-08-01T08:36:49.513Z",
                                __v: 0,
                                visitingPage: "http://localsite.supsis.live/?customer=local",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-15",
                            },
                            __v: 0,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690879030178,
                },
                delete_user: {
                    id: "1a8528b5-efa3-4a33-99fe-ef608bdf5779",
                    type: "Kullanıcı silindi",
                    data: {
                        user: [
                            {
                                _id: "64c7b9cae70c3d3bf12c4a28",
                                status: "Online",
                                subjects: [],
                                role: {
                                    _id: "5d344f1f643da6001867ba6e",
                                    siteId: "5d14ee322d95ad001ebdf213",
                                    name: "Full Admin",
                                    permissions: [],
                                    isRoot: true,
                                    isDeleted: false,
                                    createdBy: null,
                                    updatedBy: null,
                                    __v: 0,
                                    createdAt: "2023-01-05T11:29:49.116Z",
                                    updatedAt: "2023-01-05T11:29:49.116Z",
                                },
                                lastLoginIPAddress: null,
                                lastGeoLocation: null,
                                lastLoginPlatform: "web",
                                lang: "tr",
                                lastActivity: "2023-07-31T13:40:26.149Z",
                                email: "64c7b9cae70c3d3bf12c4a28*qweqwe@supsis.live",
                                name: "123ewq",
                                createdAt: "2023-07-31T13:40:26.157Z",
                                updatedAt: "2023-08-01T08:31:56.223Z",
                            },
                        ],
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878716247,
                },
                new_user: {
                    id: "8afab7e6-fed6-49d5-a058-01f2b5d88df1",
                    type: "Yeni kullanıcı oluşturuldu",
                    data: {
                        user: [
                            {
                                _id: "64c8c3a7a9388e5e600017bd",
                                status: "Online",
                                subjects: [
                                    {
                                        _id: "5d33863e17bbf7001d70e3c9",
                                        siteId: "5d14ee322d95ad001ebdf213",
                                        isActive: true,
                                        isDeleted: false,
                                        languageContent: [
                                            {
                                                name: "Teknik Destek",
                                                description: "Teknik Destek",
                                                languageCode: "tr",
                                            },
                                            {
                                                name: "Techinal Support",
                                                description: "Techinal Support",
                                                languageCode: "en",
                                            },
                                            {
                                                name: "Rusça Techinal Support",
                                                description: "Rusça Techinal Support",
                                                languageCode: "ru",
                                            },
                                        ],
                                        createdBy: null,
                                        updatedBy: null,
                                        updatedAt: "2019-08-06T17:23:23.170Z",
                                        createdAt: "2019-07-20T21:23:10.350Z",
                                        __v: 0,
                                    },
                                    {
                                        _id: "64799d49d68fc3c7cd842b6d",
                                        siteId: "5d14ee322d95ad001ebdf213",
                                        isActive: false,
                                        isDeleted: false,
                                        languageContent: [
                                            {
                                                name: "Destek",
                                                description: "wrwerwer",
                                                languageCode: "tr",
                                            },
                                            {
                                                name: "Destek",
                                                description: "wrwerwer",
                                                languageCode: "en",
                                            },
                                            {
                                                name: "Destek",
                                                description: "wrwerwer",
                                                languageCode: "ru",
                                            },
                                        ],
                                        createdBy: null,
                                        updatedBy: null,
                                        createdAt: "2023-06-02T07:42:01.779Z",
                                        updatedAt: "2023-06-02T07:42:01.779Z",
                                        __v: 0,
                                    },
                                ],
                                role: {
                                    _id: "5d344f1f643da6001867ba6e",
                                    siteId: "5d14ee322d95ad001ebdf213",
                                    name: "Full Admin",
                                    permissions: [],
                                    isRoot: true,
                                    isDeleted: false,
                                    createdBy: null,
                                    updatedBy: null,
                                    __v: 0,
                                    createdAt: "2023-01-05T11:29:49.116Z",
                                    updatedAt: "2023-01-05T11:29:49.116Z",
                                },
                                lastLoginIPAddress: null,
                                lastGeoLocation: null,
                                lastLoginPlatform: "web",
                                lang: "tr",
                                lastActivity: "2023-08-01T08:34:47.519Z",
                                email: "qweqwe123123@qwe.com",
                                name: "qwe",
                                createdAt: "2023-08-01T08:34:47.523Z",
                                updatedAt: "2023-08-01T08:34:47.523Z",
                            },
                        ],
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878887734,
                },
                destroy_chat: {
                    id: "1efe3e66-6019-41b8-8716-3fce30c2aeee",
                    type: "Konuşma sonlandırıldı",
                    data: {
                        conversation: {
                            _id: "64c8c3d7a9388e5e60001a17",
                            meta: {
                                thread: {
                                    id: null,
                                },
                                groupThread: {
                                    id: null,
                                    agents: [],
                                },
                                readTimeStamps: [],
                            },
                            note: {
                                representativeNote: null,
                                representativeName: null,
                            },
                            ipAddress: "172.20.0.1",
                            geoLocation: {
                                range: [2958721024, 2958753791],
                                country: "TR",
                                region: "",
                                eu: "0",
                                timezone: "Europe/Istanbul",
                                city: "",
                                ll: [41.0214, 28.9948],
                                metro: 0,
                                area: 500,
                            },
                            userAgent:
                                "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36",
                            notificationMute: false,
                            users: [
                                {
                                    _id: "6454c69d673677f8ecb52b78",
                                    subjects: [],
                                    role: "5d344f1f643da6001867ba6e",
                                    lastLoginIPAddress: "172.20.0.1",
                                    lastLoginUserAgent:
                                        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36",
                                    lastLoginPlatform: "web",
                                    lang: "tr",
                                    lastActivity: "2023-08-01T08:32:53.824Z",
                                    email: "bayzt.irem+34@gmail.com",
                                    name: "irem",
                                },
                            ],
                            description: null,
                            status: "destroyed",
                            destroyedByChatBot: false,
                            destroyedByVisitor: false,
                            startedWithChatBot: false,
                            videoCall: false,
                            firstMessageDate: "2023-08-01T08:35:39.126Z",
                            firstVisitorMessageDate: null,
                            lastConnectedUser: null,
                            visitingPage: "http://localsite.supsis.live/?customer=local",
                            homeSite: "localsite.supsis.live",
                            whatsappNumber: null,
                            inactive: false,
                            chatbotState: null,
                            tags: [],
                            instagramUserId: null,
                            createdDate: "2023-08-01T08:35:35.327Z",
                            visitor: {
                                _id: "64785483978d2f4ad8224744",
                                version: {
                                    version: 920,
                                    versionStr: "9.2.0",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                preferredLang: "tr",
                                tags: [],
                                connectionTime: "2023-08-01T08:26:51.756Z",
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 115.0.0 ",
                                ipAddress: "172.20.0.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                createdAt: "2023-06-01T08:19:15.628Z",
                                updatedAt: "2023-08-01T08:36:13.577Z",
                                visitingPage: "http://localsite.supsis.live/?customer=local",
                                email: "",
                            },
                            fullname: "Visitor-15",
                            email: "",
                            languageCode: "tr",
                            siteId: "5d14ee322d95ad001ebdf213",
                            ref: "web",
                            __v: 1,
                            connectedDate: "2023-08-01T08:35:35.432Z",
                            connectedUser: "6454c69d673677f8ecb52b78",
                            customLoginInfos: [],
                            destroyedDate: "2023-08-01T08:36:17.090Z",
                            destroyedUser: "6454c69d673677f8ecb52b78",
                        },
                        messages: [
                            {
                                _id: "64c8c3d7a9388e5e60001a1d",
                                siteId: "5d14ee322d95ad001ebdf213",
                                conversation: "64c8c3d7a9388e5e60001a17",
                                description: "Aramıza hoşgeldiniz",
                                baseLang: "tr",
                                createdDate: "2023-08-01T08:35:35.378Z",
                                uniqMessageId: "81c54da7-46db-417d-b1e2-f036a89d8602",
                                messageType: "system",
                                systemMessageType: "welcome-message",
                                asset: null,
                                location: null,
                                createdBy: null,
                                updatedBy: null,
                                whatsappDelivered: true,
                                translates: [],
                                __v: 0,
                            },
                            {
                                _id: "64c8c3d7a9388e5e60001a29",
                                siteId: "5d14ee322d95ad001ebdf213",
                                conversation: "64c8c3d7a9388e5e60001a17",
                                description: "Konuşmaya Irem katıldı",
                                baseLang: "tr",
                                createdDate: "2023-08-01T08:35:35.574Z",
                                uniqMessageId: "62a26d40-3046-11ee-8736-d1607565fea1",
                                messageType: "system",
                                systemMessageType: "user-login",
                                asset: null,
                                location: null,
                                createdBy: null,
                                updatedBy: null,
                                whatsappDelivered: true,
                                translates: [],
                                __v: 0,
                            },
                            {
                                _id: "64c8c3dba9388e5e60001a44",
                                baseLang: "tr",
                                messageType: "user",
                                systemMessageType: "unknown",
                                asset: null,
                                location: null,
                                updatedBy: null,
                                whatsappDelivered: false,
                                translates: [
                                    {
                                        from: "tr",
                                        to: "tr",
                                        text: "<p>asdasdds</p>",
                                        _id: "64c8c3dba9388e5e60001a45",
                                    },
                                ],
                                createdDate: "2023-08-01T08:35:39.110Z",
                                user: {
                                    _id: "6454c69d673677f8ecb52b78",
                                    subjects: [],
                                    role: {
                                        _id: "5d344f1f643da6001867ba6e",
                                        name: "Full Admin",
                                    },
                                    lastLoginIPAddress: "172.20.0.1",
                                    lastLoginUserAgent:
                                        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36",
                                    lastLoginPlatform: "web",
                                    lang: "tr",
                                    lastActivity: "2023-08-01T08:32:53.824Z",
                                    email: "bayzt.irem+34@gmail.com",
                                    name: "irem",
                                },
                                conversation: "64c8c3d7a9388e5e60001a17",
                                description: "<p>asdasdds</p>",
                                siteId: "5d14ee322d95ad001ebdf213",
                                uniqMessageId: "aeed590e-7769-4f3d-99ad-16fa0292e74b",
                                __v: 0,
                            },
                            {
                                _id: "64c8c3fda9388e5e60001a9e",
                                siteId: "5d14ee322d95ad001ebdf213",
                                conversation: "64c8c3d7a9388e5e60001a17",
                                description: "Konuşma temsilci tarafından sonlandırıldı.",
                                baseLang: "tr",
                                createdDate: "2023-08-01T08:36:13.489Z",
                                uniqMessageId: "793bf300-3046-11ee-8736-d1607565fea1",
                                messageType: "system",
                                systemMessageType: "user-destroy",
                                asset: null,
                                location: null,
                                createdBy: null,
                                updatedBy: null,
                                whatsappDelivered: true,
                                translates: [],
                                __v: 0,
                            },
                            {
                                _id: "64c8c3fda9388e5e60001aab",
                                siteId: "5d14ee322d95ad001ebdf213",
                                conversation: "64c8c3d7a9388e5e60001a17",
                                description: "Oturum kapatıldı.",
                                baseLang: "tr",
                                createdDate: "2023-08-01T08:36:13.588Z",
                                uniqMessageId: "794ae720-3046-11ee-8736-d1607565fea1",
                                messageType: "system",
                                systemMessageType: "byebye-message",
                                asset: null,
                                location: null,
                                createdBy: null,
                                updatedBy: null,
                                whatsappDelivered: true,
                                translates: [],
                                __v: 0,
                            },
                        ],
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878977134,
                },
                score_chat: {
                    id: "899ece43-6f7c-465c-88fe-523ff04dd351",
                    type: "Konuşma puanlandı",
                    data: {
                        conversation: {
                            _id: "64c8c1cda9388e5e6000101a",
                            meta: {
                                thread: {
                                    id: null,
                                },
                                groupThread: {
                                    id: null,
                                    agents: [],
                                },
                                readTimeStamps: [],
                            },
                            note: {
                                representativeNote: null,
                                representativeName: null,
                            },
                            ipAddress: "172.20.0.1",
                            geoLocation: {
                                range: [2958721024, 2958753791],
                                country: "TR",
                                region: "",
                                eu: "0",
                                timezone: "Europe/Istanbul",
                                city: "",
                                ll: [41.0214, 28.9948],
                                metro: 0,
                                area: 500,
                            },
                            userAgent:
                                "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36",
                            notificationMute: false,
                            users: [],
                            description: "22222",
                            status: "destroyed",
                            destroyedByChatBot: true,
                            destroyedByVisitor: false,
                            startedWithChatBot: true,
                            videoCall: false,
                            firstMessageDate: "2023-08-01T08:26:55.203Z",
                            firstVisitorMessageDate: null,
                            lastConnectedUser: null,
                            visitingPage: "http://localsite.supsis.live/?customer=local",
                            homeSite: "localsite.supsis.live",
                            whatsappNumber: null,
                            inactive: false,
                            chatbotState: {
                                storyId: "63bff08ca787b31f6de83c2f",
                                storyVersion: "6.0",
                                version: 1,
                                id: "8314ebf8-be88-4854-a99b-101dc335e46a",
                                position: "f8ec7b8636",
                                history: ["cf0e87338f", "0773f3363e", "f8ec7b8636"],
                                responseWaiting: false,
                                busy: false,
                                closed: true,
                                failed: true,
                                userInputAllowed: false,
                                conversationId: "64c8c1cda9388e5e6000101a",
                                attributes: {
                                    score: "",
                                    failures: 0,
                                    message: "sf",
                                    email: "",
                                    name: "Visitor-15",
                                    username: "",
                                    source: "",
                                    language: "tr",
                                    region: "",
                                    referrer: "",
                                    url: "http://localsite.supsis.live/?customer=local",
                                    ip: "172.20.0.1",
                                    lastSeen: "",
                                    userId: "",
                                    integration: "web",
                                    platform: "web",
                                    phone: "",
                                    user_id: "64785483978d2f4ad8224744",
                                    hostname: "localsite.supsis.live",
                                },
                                passedGotoStepBlockIds: [],
                                integration: "web",
                            },
                            tags: [],
                            instagramUserId: null,
                            createdDate: "2023-08-01T08:26:53.064Z",
                            visitor: {
                                _id: "64785483978d2f4ad8224744",
                                version: {
                                    version: 920,
                                    versionStr: "9.2.0",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                isDeleted: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                preferredLangApproved: false,
                                tags: [],
                                preferredAgents: [],
                                connectionTime: "2023-08-01T08:26:51.756Z",
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 115.0.0 ",
                                ipAddress: "172.20.0.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                siteId: "5d14ee322d95ad001ebdf213",
                                createdAt: "2023-06-01T08:19:15.628Z",
                                updatedAt: "2023-08-01T08:29:42.389Z",
                                __v: 0,
                                visitingPage: "http://localsite.supsis.live/?customer=local",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-15",
                            },
                            fullname: "Visitor-15",
                            email: "",
                            languageCode: "tr",
                            siteId: "5d14ee322d95ad001ebdf213",
                            ref: "web",
                            __v: 1,
                            chatbotStory: "63bff08ca787b31f6de83c2f",
                            chatbotStoryVersion: "6.0",
                            customLoginInfos: [],
                            destroyedDate: "2023-08-01T08:26:59.684Z",
                            point: 2,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878686892,
                },
                update_user: {
                    id: "73f913de-f345-4974-80ed-96715a697bb2",
                    type: "Kullanıcı güncellendi",
                    data: {
                        user: [
                            {
                                _id: "64c7ba88e70c3d3bf12c5602",
                                status: "Online",
                                subjects: [],
                                role: {
                                    _id: "5d344f1f643da6001867ba6e",
                                    siteId: "5d14ee322d95ad001ebdf213",
                                    name: "Full Admin",
                                    permissions: [],
                                    isRoot: true,
                                    isDeleted: false,
                                    createdBy: null,
                                    updatedBy: null,
                                    __v: 0,
                                    createdAt: "2023-01-05T11:29:49.116Z",
                                    updatedAt: "2023-01-05T11:29:49.116Z",
                                },
                                lastLoginIPAddress: null,
                                lastGeoLocation: null,
                                lastLoginPlatform: "web",
                                lang: "tr",
                                lastActivity: "2023-07-31T13:43:36.528Z",
                                email: "aasdasdadsdmin@supsis.live",
                                name: "admin@supsis.live",
                                createdAt: "2023-07-31T13:43:36.530Z",
                                updatedAt: "2023-08-01T08:35:02.453Z",
                            },
                        ],
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2023-04-07T15:31:45.666Z",
                        createdAt: "2022-09-29T14:52:56.370Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: "qwe",
                        rootUserName: "qwe",
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1690878902480,
                },
                incoming_message: {
                    id: "d2d94216f7",
                    type: "Gelen mesaj",
                    data: {
                        conversation: {
                            _id: "666ad93e979ec21fe2c67495",
                            meta: {
                                thread: {
                                    id: null,
                                },
                                groupThread: {
                                    id: null,
                                    agents: [],
                                    groupProfilePicture: null,
                                },
                                readTimeStamps: [],
                            },
                            notificationMute: false,
                            users: [
                                {
                                    _id: "5d14ee322d95ad001ebdf214",
                                    email: "demo@gmail.com",
                                    name: "demo@gmail.com",
                                    subjects: [],
                                    role: "5d344f1f643da6001867ba6e",
                                    lastLoginIPAddress: "192.168.65.1",
                                    lastLoginUserAgent:
                                        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                                    lastLoginPlatform: "web",
                                    lang: "en",
                                    lastActivity: "2024-06-13T11:39:31.534Z",
                                },
                            ],
                            status: "active",
                            startedFrom: "visitor",
                            destroyedByChatBot: false,
                            destroyedByVisitor: false,
                            startedWithChatBot: false,
                            videoCall: false,
                            firstMessageDate: "2024-06-13T11:42:44.399Z",
                            firstVisitorMessageDate: null,
                            lastConnectedUser: null,
                            inactive: false,
                            tags: [],
                            isLost: false,
                            duration: 0,
                            isMissed: false,
                            handledBy: "none",
                            agentWaitTime: 0,
                            createdDate: "2024-06-13T11:34:22.766Z",
                            visitor: {
                                _id: "6613b2755b45549fc6975ff8",
                                version: {
                                    version: 1113,
                                    versionStr: "11.1.3",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                phoneVerified: false,
                                emailVerified: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                tags: [],
                                channel: null,
                                contacted: true,
                                connectionTime: "2024-06-13T11:34:25.119Z",
                                metaReferrals: [],
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 124.0.0 ",
                                ipAddress: "192.168.65.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                createdAt: "2024-04-08T09:01:41.934Z",
                                updatedAt: "2024-06-13T11:34:25.128Z",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-1",
                            },
                            fullname: "Visitor-1",
                            languageCode: "tr",
                            agentWaitStartDate: "2024-06-13T11:34:22.766Z",
                            visitingPage: "http://localsite.supsis.live/",
                            homeSite: "localsite.supsis.live",
                            ipAddress: "192.168.65.1",
                            geoLocation: {
                                range: [2958741504, 2958745599],
                                country: "TR",
                                region: "06",
                                eu: "0",
                                timezone: "Europe/Istanbul",
                                city: "Ankara",
                                ll: [39.9442, 32.8747],
                                metro: 0,
                                area: 200,
                            },
                            userAgent:
                                "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                            siteId: "5d14ee322d95ad001ebdf213",
                            ref: "web",
                            __v: 1,
                            connectedDate: "2024-06-13T11:34:25.060Z",
                            connectedUser: {
                                _id: "5d14ee322d95ad001ebdf214",
                                email: "demo@gmail.com",
                                name: "demo@gmail.com",
                            },
                            agentLostTs: "2024-06-13T11:39:25.599Z",
                            customLoginInfos: [],
                        },
                        message: {
                            _id: "666adcf466d4e1c09727091c",
                            siteId: "5d14ee322d95ad001ebdf213",
                            conversation: "666ad93e979ec21fe2c67495",
                            description: "Merhaba bana yardım edebilecek birisi varmıdır? ",
                            baseLang: "tr",
                            createdDate: "2024-06-13T11:50:12.669Z",
                            uniqMessageId: "68338e29-6718-4d24-9130-60bc24991c14",
                            fromBroadcast: false,
                            fromAPI: false,
                            messageType: "visitor",
                            systemMessageType: "unknown",
                            mail: null,
                            asset: null,
                            location: null,
                            createdBy: null,
                            updatedBy: null,
                            whatsappDelivered: true,
                            whatsappBusinessMessageId: null,
                            gupshupMessageId: null,
                            lastWhatsappBusinessStatus: {
                                status: null,
                                reason: null,
                            },
                            replyTo: null,
                            isDeleted: false,
                            translates: [],
                            __v: 0,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2024-04-05T09:41:40.169Z",
                        createdAt: "2024-04-05T09:41:40.169Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: null,
                        rootUserName: null,
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1718279412765,
                    webhookType: "incoming_message",
                },
                outgoing_message: {
                    id: "c6741d06c5",
                    type: "Gelen mesaj",
                    data: {
                        conversation: {
                            _id: "666ad93e979ec21fe2c67495",
                            meta: {
                                thread: {
                                    id: null,
                                },
                                groupThread: {
                                    id: null,
                                    agents: [],
                                    groupProfilePicture: null,
                                },
                                readTimeStamps: [],
                            },
                            notificationMute: false,
                            users: [
                                {
                                    _id: "5d14ee322d95ad001ebdf214",
                                    email: "demo@gmail.com",
                                    name: "demo@gmail.com",
                                    subjects: [],
                                    role: "5d344f1f643da6001867ba6e",
                                    lastLoginIPAddress: "192.168.65.1",
                                    lastLoginUserAgent:
                                        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                                    lastLoginPlatform: "web",
                                    lang: "en",
                                    lastActivity: "2024-06-13T11:39:31.534Z",
                                },
                            ],
                            status: "active",
                            startedFrom: "visitor",
                            destroyedByChatBot: false,
                            destroyedByVisitor: false,
                            startedWithChatBot: false,
                            videoCall: false,
                            firstMessageDate: "2024-06-13T11:42:44.399Z",
                            firstVisitorMessageDate: null,
                            lastConnectedUser: null,
                            inactive: false,
                            tags: [],
                            isLost: false,
                            duration: 0,
                            isMissed: false,
                            handledBy: "none",
                            agentWaitTime: 0,
                            createdDate: "2024-06-13T11:34:22.766Z",
                            visitor: {
                                _id: "6613b2755b45549fc6975ff8",
                                version: {
                                    version: 1113,
                                    versionStr: "11.1.3",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                phoneVerified: false,
                                emailVerified: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                tags: [],
                                channel: null,
                                contacted: true,
                                connectionTime: "2024-06-13T11:34:25.119Z",
                                metaReferrals: [],
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 124.0.0 ",
                                ipAddress: "192.168.65.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                createdAt: "2024-04-08T09:01:41.934Z",
                                updatedAt: "2024-06-13T11:34:25.128Z",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-1",
                            },
                            fullname: "Visitor-1",
                            languageCode: "tr",
                            agentWaitStartDate: "2024-06-13T11:34:22.766Z",
                            visitingPage: "http://localsite.supsis.live/",
                            homeSite: "localsite.supsis.live",
                            ipAddress: "192.168.65.1",
                            geoLocation: {
                                range: [2958741504, 2958745599],
                                country: "TR",
                                region: "06",
                                eu: "0",
                                timezone: "Europe/Istanbul",
                                city: "Ankara",
                                ll: [39.9442, 32.8747],
                                metro: 0,
                                area: 200,
                            },
                            userAgent:
                                "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                            siteId: "5d14ee322d95ad001ebdf213",
                            ref: "web",
                            __v: 1,
                            connectedDate: "2024-06-13T11:34:25.060Z",
                            connectedUser: {
                                _id: "5d14ee322d95ad001ebdf214",
                                email: "demo@gmail.com",
                                name: "demo@gmail.com",
                            },
                            agentLostTs: "2024-06-13T11:39:25.599Z",
                            customLoginInfos: [],
                        },
                        message: {
                            _id: "666adc7634eb253cf75c4d05",
                            lastWhatsappBusinessStatus: {
                                status: null,
                                reason: null,
                            },
                            baseLang: "tr",
                            fromBroadcast: false,
                            fromAPI: false,
                            messageType: "user",
                            systemMessageType: "unknown",
                            mail: null,
                            asset: null,
                            location: null,
                            updatedBy: null,
                            whatsappDelivered: false,
                            whatsappBusinessMessageId: null,
                            gupshupMessageId: null,
                            replyTo: null,
                            isDeleted: false,
                            translates: [
                                {
                                    from: "en",
                                    to: "tr",
                                    text: "<p>asdados</p>",
                                    _id: "666adc7634eb253cf75c4d06",
                                },
                            ],
                            createdDate: "2024-06-13T11:48:06.113Z",
                            user: {
                                _id: "5d14ee322d95ad001ebdf214",
                                email: "demo@gmail.com",
                                name: "demo@gmail.com",
                            },
                            conversation: "666ad93e979ec21fe2c67495",
                            description: "<p>asdadas</p>",
                            siteId: "5d14ee322d95ad001ebdf213",
                            uniqMessageId: "ccf39748-71e9-4589-8373-99d5b0281468",
                            __v: 0,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2024-04-05T09:41:40.169Z",
                        createdAt: "2024-04-05T09:41:40.169Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: null,
                        rootUserName: null,
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1718279286187,
                    webhookType: "outgoing_message",
                },
                message_updated: {
                    id: "c6741d06c5",
                    type: "Mesaj güncellendi",
                    data: {
                        conversation: {
                            _id: "666ad93e979ec21fe2c67495",
                            meta: {
                                thread: {
                                    id: null,
                                },
                                groupThread: {
                                    id: null,
                                    agents: [],
                                    groupProfilePicture: null,
                                },
                                readTimeStamps: [],
                            },
                            notificationMute: false,
                            users: [
                                {
                                    _id: "5d14ee322d95ad001ebdf214",
                                    email: "demo@gmail.com",
                                    name: "demo@gmail.com",
                                    subjects: [],
                                    role: "5d344f1f643da6001867ba6e",
                                    lastLoginIPAddress: "192.168.65.1",
                                    lastLoginUserAgent:
                                        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                                    lastLoginPlatform: "web",
                                    lang: "en",
                                    lastActivity: "2024-06-13T11:39:31.534Z",
                                },
                            ],
                            status: "active",
                            startedFrom: "visitor",
                            destroyedByChatBot: false,
                            destroyedByVisitor: false,
                            startedWithChatBot: false,
                            videoCall: false,
                            firstMessageDate: "2024-06-13T11:42:44.399Z",
                            firstVisitorMessageDate: null,
                            lastConnectedUser: null,
                            inactive: false,
                            tags: [],
                            isLost: false,
                            duration: 0,
                            isMissed: false,
                            handledBy: "none",
                            agentWaitTime: 0,
                            createdDate: "2024-06-13T11:34:22.766Z",
                            visitor: {
                                _id: "6613b2755b45549fc6975ff8",
                                version: {
                                    version: 1113,
                                    versionStr: "11.1.3",
                                    buildNumber: -1,
                                    commitHash: "",
                                },
                                platform: "web",
                                phoneVerified: false,
                                emailVerified: false,
                                instagramUserId: null,
                                instagramInfo: null,
                                telegramUserId: null,
                                telegramInfo: null,
                                preferredLang: "tr",
                                tags: [],
                                channel: null,
                                contacted: true,
                                connectionTime: "2024-06-13T11:34:25.119Z",
                                metaReferrals: [],
                                os: " Mac OS X 10.15.7",
                                browser: "Chrome 124.0.0 ",
                                ipAddress: "192.168.65.1",
                                country: "N/A",
                                city: "N/A",
                                status: "visitor",
                                createdAt: "2024-04-08T09:01:41.934Z",
                                updatedAt: "2024-06-13T11:34:25.128Z",
                                whatsappInfo: {
                                    isBusiness: false,
                                    isEnterprise: "false",
                                    isMe: false,
                                    isMyContact: false,
                                    isPSA: false,
                                    isUser: false,
                                    isWAContact: false,
                                },
                                email: "",
                                fullname: "Visitor-1",
                            },
                            fullname: "Visitor-1",
                            languageCode: "tr",
                            agentWaitStartDate: "2024-06-13T11:34:22.766Z",
                            visitingPage: "http://localsite.supsis.live/",
                            homeSite: "localsite.supsis.live",
                            ipAddress: "192.168.65.1",
                            geoLocation: {
                                range: [2958741504, 2958745599],
                                country: "TR",
                                region: "06",
                                eu: "0",
                                timezone: "Europe/Istanbul",
                                city: "Ankara",
                                ll: [39.9442, 32.8747],
                                metro: 0,
                                area: 200,
                            },
                            userAgent:
                                "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
                            siteId: "5d14ee322d95ad001ebdf213",
                            ref: "web",
                            __v: 1,
                            connectedDate: "2024-06-13T11:34:25.060Z",
                            connectedUser: {
                                _id: "5d14ee322d95ad001ebdf214",
                                email: "demo@gmail.com",
                                name: "demo@gmail.com",
                            },
                            agentLostTs: "2024-06-13T11:39:25.599Z",
                            customLoginInfos: [],
                        },
                        message: {
                            _id: "666adc7634eb253cf75c4d05",
                            lastWhatsappBusinessStatus: {
                                status: null,
                                reason: null,
                            },
                            baseLang: "tr",
                            fromBroadcast: false,
                            fromAPI: false,
                            messageType: "user",
                            systemMessageType: "unknown",
                            mail: null,
                            asset: null,
                            location: null,
                            updatedBy: null,
                            whatsappDelivered: false,
                            whatsappBusinessMessageId: null,
                            gupshupMessageId: null,
                            replyTo: null,
                            isDeleted: false,
                            translates: [
                                {
                                    from: "en",
                                    to: "tr",
                                    text: "<p>asdados</p>",
                                    _id: "666adc7634eb253cf75c4d06",
                                },
                            ],
                            createdDate: "2024-06-13T11:48:06.113Z",
                            user: {
                                _id: "5d14ee322d95ad001ebdf214",
                                email: "demo@gmail.com",
                                name: "demo@gmail.com",
                            },
                            conversation: "666ad93e979ec21fe2c67495",
                            description: "<p>asdadas</p>",
                            siteId: "5d14ee322d95ad001ebdf213",
                            uniqMessageId: "ccf39748-71e9-4589-8373-99d5b0281468",
                            __v: 0,
                        },
                    },
                    site: {
                        _id: "5d14ee322d95ad001ebdf213",
                        updatedAt: "2024-04-05T09:41:40.169Z",
                        createdAt: "2024-04-05T09:41:40.169Z",
                        siteAddress: "local.supsis.live",
                        clientAddress: "local.supsis.live",
                        customerClientAddress: "localvisitor.supsis.live",
                        alias: "supsis",
                        rootUserEmail: null,
                        rootUserName: null,
                        partner: null,
                        phone: null,
                        suspend: false,
                        enable: true,
                    },
                    ts: 1718279286187,
                    webhookType: "message_updated",
                },
            },
        };
    },
    computed: {
        ...mapState({
            allWebHooks: (state) => state.customerWebhook.allWebHooks,
            languages: (state) => state.language.languages,
        }),
    },

    methods: {
        ...mapActions({
            addNewWebHook: "customerWebhook/addNewWebHook",
            updateWebHook: "customerWebhook/updateWebHook",
            fetchUserWebHooks: "customerWebhook/fetchUserWebHooks",
        }),
        highlighter(code) {
            return highlight(code, languages.json); // languages.<insert language> to return html with markup
        },
        openPreview(hookName) {
            this.previewActive = true;
            this.selectedHook = hookName;
        },
        onChange(checked) {
            const index = this.form.options.findIndex((c) => c === checked);
            const isSwitchedOff = !!this.form.options.length ? index !== -1 : false;
            if (!isSwitchedOff) this.form.options.push(checked);
            else this.form.options.splice(index, 1);
            console.log("this.form.checkedList", this.form.options);
        },
        urlInputOnBlurHandler() {
            try {
                new window.URL(this.form.url);
                this.urlError = false;
            } catch (e) {
                this.urlError = true;
            }
        },
        selectOption(hook) {
            const result = this.form.options.filter((option) => option === hook.name);
            return result.length > 0;
        },
        async saveButtonClickHandler() {
            this.isSubmitClicked = true;
            this.loading = true;
            this.$validator.validateAll().then(async (response) => {
                if (response) {
                    if (this.form.name && this.form.url) {
                        this.form.headers = this.anotherHeaders.filter((header) => header.key !== "");
                        //update

                        if (this.isUpdate) {
                            await this.updateWebHook({ id: this.$route.params.id, payload: this.form });
                            this.isSubmitClicked = false;

                            this.$router.push({ name: "integrations-webhook" });
                            this.loading = false;
                            return message.success(this.$t("chatbotv2.saveSuccessfully"));
                        }
                        //save
                        await this.addNewWebHook(this.form);
                        this.isSubmitClicked = false;

                        this.$router.push({ name: "integrations-webhook" });
                        this.loading = false;
                        return message.success(this.$t("chatbotv2.saveSuccessfully"));
                    }
                } else {
                    this.loading = false;
                }
            });
            // return message.error(this.$t("chatbotv2.requiredFieldsCannotBeLeftBlank") + "(*)");
        },

        deleteHeader(headerIndex) {
            this.anotherHeaders = this.anotherHeaders.filter((header, index) => headerIndex !== index);
        },
    },
    async mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 1000);
        if (this.$route.params.id) {
            this.isUpdate = true;
            console.log("this.allWebHooks", this.allWebHooks);
            this.form = this.allWebHooks.find((webHook) => webHook._id === this.$route.params.id);
            this.anotherHeaders = this.form.headers;
        }
    },
    watch: {
        anotherHeaders: {
            handler() {
                let allFilled = this.anotherHeaders.every((header) => header.key !== "");
                this.anotherHeaders.forEach((elem, index, arr) => {
                    if (elem.key === "" && elem.value === "") this.countEmptyHeader++;
                });
                if (allFilled) {
                    this.anotherHeaders.push({ key: "", value: "" });
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#web-hook {
    display: flex;
    background-color: rgb(255, 255, 255);
    min-height: 100vh;

    #side-menu-bar {
        min-width: 220px;
        min-height: 100vh;
    }

    .web-hook-container {
        width: 100%;
        padding: 20px 25px;
        height: auto;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .page-name {
                display: flex;
                font-size: 27px;
                line-height: 28px;
                user-select: none;

                .routes {
                    display: flex;
                    margin-right: 15px;

                    p {
                        cursor: pointer;
                        color: #516173;
                        transition: 3ms;
                        margin: 0;
                        padding: 0;
                        margin-right: 10px;
                        font-size: 22px;
                        line-height: 28px;
                    }

                    .arrow {
                        cursor: pointer;
                        font-size: 22px;
                        line-height: 28px;
                    }

                    &:hover {
                        p {
                            color: #006cff;
                            opacity: 0.8;
                        }

                        .arrow {
                            color: #006cff;
                            opacity: 0.8;
                        }
                    }
                }

                .web-hook-name {
                    font-size: 22px;
                    line-height: 28px;
                }
            }

            .button-container {
                height: 37px;
                min-width: 80px;
                cursor: pointer;
                user-select: none;

                .save-button {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #006cff;
                    border: 1px solid #006cff;
                    color: #fff;
                    border-radius: 4px;
                    padding: 0px 10px;
                    color: white;
                    font-weight: 600;
                }
            }
        }

        .ant-form {
            margin-top: 20px;

            .form-subtitle {
                margin-bottom: 3px;
                font-size: 16px;
                line-height: 20px;
                color: #22272d;
            }

            .ant-form-item {
                margin-bottom: 25px !important;

                input {
                    min-height: 37px !important;
                    border-radius: 6px !important;
                }
            }

            .headers-group {
                margin-bottom: 50px;

                .headers {
                    display: flex;
                    align-items: center;

                    .ant-form-item {
                        margin-bottom: 5px !important;
                    }

                    .delete-button {
                        cursor: pointer;
                        width: 24px;
                        height: 24px;
                        margin-bottom: 5px;

                        i {
                            width: 100%;
                            height: 100%;
                            color: #9ba6b3;
                        }

                        &:hover {
                            i {
                                opacity: 0.8 !important;
                            }
                        }
                    }
                }
            }
        }

        .card-wrapper-switches {
            display: flex;
            flex-direction: column;

            #visibleBtn {
                background: transparent;
                border: none;
                margin-left: 1.5rem;
            }
        }
    }
}

#previewModal {
    #previewArea {
        height: 75vh;
        overflow: scroll;
    }

    .ant-modal {
        width: 800px !important;
    }
}

.relative-header {
    width: calc(100% - 36px);
}

.new-hook-bread-crumb {
    padding: 5px 0 !important;
    margin-top: -18px !important;
    margin-bottom: 7px !important;
    border-bottom: 1px solid #ebedf3 !important;
}
</style>
